module.exports = __webpack_public_path__ + "img/close.9c2baac2.svg";